<template>
  <Component
    :is="props.is"
    class="ds-card"
    :class="{ 'tw-relative': !!$slots['action-bar'], '--border': border, '--narrow': narrow }"
  >
    <slot name="pre-header"></slot>
    <header v-if="$slots.header" class="ds-card-header">
      <slot name="header"></slot>
    </header>
    <div class="ds-card-body">
      <slot></slot>
    </div>
    <footer
      v-if="$slots.actions || $slots['action-bar']"
      class="ds-card-footer"
      :class="{ '--action-bar': $slots['action-bar'] }"
    >
      <slot name="actions"></slot>
      <slot name="action-bar"></slot>
    </footer>
  </Component>
</template>

<script setup lang="ts">
const props = defineProps({
  is: {
    type: String,
    default: 'article',
  },
  border: {
    type: Boolean,
    default: false,
  },
  narrow: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.ds-card {
  @apply tw-flex tw-flex-col tw-w-128 tw-rounded-sm tw-p-6 tw-bg-white tw-shadow-xl tw-space-y-4 tw-overflow-hidden;
}
.ds-card.--narrow {
  @apply tw-p-4;
}
.ds-card.--border {
  @apply tw-border-solid tw-border tw-border-cool-grey-200;
}
.ds-card-header {
  @apply tw-flex tw-items-center tw-justify-between;
}
.ds-card-body {
  @apply tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden;
}
.ds-card-footer {
  @apply tw-flex tw-items-center tw-gap-4 tw-justify-between tw-mt-8;
}
.ds-card-footer.--action-bar {
  @apply tw-absolute tw-right-0 tw-bottom-0 tw-min-w-full tw-p-6 tw-bg-white tw-rounded-b-sm;
  @apply tw-border-0 tw-border-t tw-border-solid tw-border-t-cool-grey-200;
}
</style>
